import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../../api/config';

const layoutPositions = [
  { rotation: -5, top: '5%', left: '10%' },
  { rotation: 3, top: '15%', left: '30%' },
  { rotation: -8, top: '10%', left: '50%' },
  { rotation: 6, top: '25%', left: '64%' },
  { rotation: -3, top: '40%', left: '20%' },
  { rotation: 7, top: '35%', left: '55%' },
  { rotation: 0, top: '50%', left: '40%' }
];

const PhotoCollage = () => {
  const [photos, setPhotos] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/polaroid_collage/read`
        );
        const data = await response.json();
        const arr = Array.isArray(data) ? data : (data.data || []);
        const visiblePhotos = arr.slice(0, 7);
        setPhotos(visiblePhotos);
      } catch (error) {
        console.error("Error fetching photos:", error);
      }
    };

    fetchPhotos();

    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`photo-collage-container ${isVisible ? 'visible' : ''}`}>
      <div className="collage-title-section">
        <h2 className="collage-main-title">Ethiccraft Memories?</h2>
        <p className="collage-subtitle">
          {/* Découvrez des souvenirs inoubliables et des paysages à couper le souffle.
          Chaque photo raconte une histoire, quelle sera la vôtre? */}
        </p>
      </div>

      <div className="collage-area">
        {photos.map((photo, index) => {
          const layout = layoutPositions[index];

          return (
            <div
              key={photo.id}
              className="polaroid-card"
              style={{
                transform: `rotate(${layout.rotation}deg)`,
                top: layout.top,
                left: layout.left,
                animationDelay: `${index * 0.1 + 0.5}s`,
                zIndex: index
              }}
            >
              <div className="polaroid-image-wrapper">
                <img
                  src={`https://ethiccraft.org/${photo.image}`}
                  alt={photo.caption}
                  className="polaroid-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://placehold.co/300x300/CCCCCC/333?text=Error";
                  }}
                />
              </div>
              <p className="polaroid-caption">{photo.caption}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PhotoCollage;